/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
import Dropdown from './dropdown'

type Props = {
    type: 'link' | 'dropdown'
    link?: any
    route?: true | false
    description?: string
    title: string
}

const Item: React.FC<Props> = ({ type, route, link, title, description, children }) => {
    return (
        <>
            <li className="px-3.5">
                {type === 'link' ?
                    route === true ?
                        <Link to={link} className="text-gray-200 hover:underline text-lg font-medium">
                            {title}
                        </Link>
                    :
                        <a href={link} className="text-gray-200 hover:underline text-lg font-medium">
                            {title}
                        </a>
                :
                    <>
                        <span className="text-gray-100 text-lg font-medium flex items-center cursor-pointer">
                            {title}
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-1.5 mt-0.5 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </span>
                        <Dropdown title={title} description={description}>
                            {children}
                        </Dropdown>
                    </>
                }
            </li>
        </>
    )
}

export default Item